import React from 'react';
import Icon from '../Icon';

/**
 * Рубрика й дати статті.
 *
 * Раніше рубрика стояла жовтою плашкою — єдиний жовтий на сайті, де решта
 * акцентів бірюзові, і на сторінці статті вона читалася як попередження.
 * Дата оновлення була лише на сторінці статті й лише в бічній колонці, яка
 * на телефоні опинялася під усім текстом. Тут обидві дати стоять поруч і
 * однаково на картці в блозі та над статтею: у тексті про строки людині
 * важливо одразу бачити, наскільки він свіжий.
 *
 * Перед датою оновлення — значок календаря, а не риска-роздільник: коли
 * рядок переноситься, риска лишалася висіти в кінці першого рядка, а значок
 * завжди стоїть на початку того, що позначає.
 */
const ArticleMeta = ({ article, className = '' }) => (
  <div className={`flex flex-wrap items-center gap-x-4 gap-y-2 text-sm text-slate-600 ${className}`}>
    <span className="inline-flex items-center rounded-full border border-teal-100 bg-teal-50 px-3 py-1 text-xs font-semibold uppercase tracking-[0.14em] text-teal-800">
      {article.tag}
    </span>
    <span>
      {'Опубліковано '}
      <time dateTime={article.date}>{article.dateLabel}</time>
    </span>
    {article.updated && (
      <span className="inline-flex items-center gap-2 font-medium text-slate-700">
        <Icon name="fa-calendar-check" className="text-teal-700" />
        <span>
          {'Оновлено '}
          <time dateTime={article.updated}>{article.updatedLabel}</time>
        </span>
      </span>
    )}
  </div>
);

export default ArticleMeta;
